import dayjs from 'dayjs';

export const timeOptions = (): string[] => {
  const options = [];
  const start = dayjs().hour(0).minute(0).second(1);
  // Let's display each time option every 15 minutes
  const totalOfTimeSlots = 96; // 24 hours divided by 15 min

  for (let i = 0; i < totalOfTimeSlots; i++) {
    // It's important to save startTime/endTime format as `2023-03-28 14:30` wihtout am/pm values to not break dayjs format
    options.push(start.add(15 * i, 'minute').format('HH:mm'));
  }
  return options;
};
